import gql from 'graphql-tag';

const GET_ORG_SUMMARY = gql`
  query org($loggedInOrg: ID) {
    org(where: { id: $loggedInOrg }) {
      name
      id
      level
      orgSummary {
        id
        impressions
        mediaSpendCTR
        totalCampaigns
        activeCampaigns
        liveCampaigns
        inAttributionCampaigns
        mediaSpendBudgetSpent
        mediaSpendImpressionsServed
        mediaSpendClicks
        budget
        goal
        roas
        totalWalkIns
        totalOrders
        totalObservations
        totalRevenue
        attributionWindowReport
        createdAt
        updatedAt
      }
    }
  }
`;

export default GET_ORG_SUMMARY;
